import Access from "./Access";
import Access_v1 from "./Access_v1";
import Approval from "./Approval";
import Approval_v1 from "./Approval_v1";
import Initialization from "./Initialization";
import Initialization_v1 from "./Initialization_v1";
import Intent from "./Intent";
import Intent_v1 from "./Intent_v1";
import Login from "./Login";
import Login_v1 from "./Login_v1";
import Notification from "./Notification";
import Notification_v1 from "./Notification_v1";
import Plan from "./Plan";
import Plan_v1 from "./Plan_v1";
import Push from "./Push";
import Push_v1 from "./Push_v1";
import Task from "./Task";
import Task_v1 from "./Task_v1";
import Trigger from "./Trigger";
import Trigger_v1 from "./Trigger_v1";

const templatesV0 = {
  ACCESS: Access,
  APPROVAL: Approval,
  INITIALIZATION: Initialization,
  LOGIN: Login,
  PLAN: Plan,
  PUSH: Push,
  TASK: Task,
  TRIGGER: Trigger,
  NOTIFICATION: Notification,
  INTENT: Intent,
};
const templatesV1 = {
  ACCESS: Access_v1,
  APPROVAL: Approval_v1,
  INITIALIZATION: Initialization_v1,
  LOGIN: Login_v1,
  PLAN: Plan_v1,
  PUSH: Push_v1,
  TASK: Task_v1,
  TRIGGER: Trigger_v1,
  NOTIFICATION: Notification_v1,
  INTENT: Intent_v1,
};

export { templatesV0, templatesV1 };
